import { v4 as uuidv4 } from 'uuid';

import { CommandLauncherCreateActionFn } from '../commandLauncher.types';

/**
 * Creates a command launcher action with a unique id.
 *
 * @param action The action parameters.
 */
export const createCommandLauncherAction: CommandLauncherCreateActionFn = (
  action,
) => {
  return {
    ...action,
    id: uuidv4(),
  };
};
